const e = {
  color: Object,
  type: {
    type: String,
    default: "default"
  },
  round: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  closable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  }
};
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tag/src/common-props.js
// module id = 1748
// module chunks = 67